/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';  
import { getAllOrgsAuthProviders, getAllOrgsAuthProvidersByOrgID, getOrgAuthProviderHistory } from './orgAuthProviderAction';
 
const initialState = {
    data: {},
    orgAuthProvider: {},
    orgAuthProviderHistory: {}
}
const orgAuthProviderSlice = createSlice({
    name: 'orgAuthProvider',
    initialState,
    extraReducers: {

        [getAllOrgsAuthProviders.fulfilled]: (state, { payload }) => {
            state.orgAuthProvider =  payload;
        },
        [getAllOrgsAuthProvidersByOrgID.fulfilled]: (state, { payload }) => {
            state.orgAuthProvider =  payload;
        },
        [getOrgAuthProviderHistory.fulfilled]: (state, { payload }) => {
            state.orgAuthProviderHistory =  payload;
        },
        [getOrgAuthProviderHistory.rejected]: (state, { payload }) => {
            state.orgAuthProviderHistory =  {};
        },
    }
});

export default orgAuthProviderSlice.reducer